import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Header from './Header/header'
import Footer from '../sections/Footer'
import '../i18n'
import Cursor from './Cursor'
import { Box, ChakraProvider } from '@chakra-ui/react'
import { ChakraTheme } from '../theme/theme'
import { screenSizes } from '../lib/constants'

import { useTranslation } from 'react-i18next'
import MobileHeader from './MobileHeader'
import CustomCookieConsent from './CookieConsent'

const MobileHeaderDiv = styled.div`
    display: none;

    @media (max-width: ${screenSizes.lg}px) {
        display: block;
    }
`

const DesktopHeaderDiv = styled.div`
    display: none;

    @media (min-width: ${screenSizes.lg}px) {
        display: block;
    }
`

const GlobalWrapper = styled.div`
    //padding-top: 100px;
`

const Layout = ({ children }) => {
    const { i18n } = useTranslation()

    return (
        <ChakraProvider theme={ChakraTheme}>
            <GlobalWrapper lang={i18n.language}>
                <Box>
                    <DesktopHeaderDiv>
                        <Header />
                    </DesktopHeaderDiv>
                </Box>
                <Box>
                    <MobileHeaderDiv>
                        <MobileHeader />
                    </MobileHeaderDiv>
                </Box>
                <main>
                    <Box className={'mainContent'} pb={[10]}>
                        {children}
                    </Box>
                </main>
                <Footer />
                <CustomCookieConsent />
            </GlobalWrapper>
            <Cursor />
        </ChakraProvider>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
    homepage: PropTypes.bool,
}

export default Layout
